import React from 'react';
import { company } from '../mock';

const Section = ({ title, children }) => (
  <section className="mb-10">
    <h2 className="font-serif text-2xl md:text-3xl mb-4">{title}</h2>
    <div className="text-black/75 leading-relaxed space-y-3">{children}</div>
  </section>
);

const Cgv = () => {
  return (
    <div className="pt-[72px] bg-white">
      <section className="bg-black text-white py-16">
        <div className="max-w-[900px] mx-auto px-6 lg:px-10">
          <p className="text-[11px] tracking-[0.4em] uppercase text-white/60">Légal</p>
          <h1 className="font-serif text-5xl md:text-6xl mt-3">Conditions Générales de Vente</h1>
        </div>
      </section>

      <article className="py-16">
        <div className="max-w-[900px] mx-auto px-6 lg:px-10 text-[15px]">
          <p className="text-black/60 mb-10">
            Les présentes Conditions Générales de Vente (« CGV ») régissent les relations entre la société
            <strong> Ha Transport SARL</strong> (ci-après « le Prestataire ») et toute personne physique ou
            morale (ci-après « le Client ») souhaitant bénéficier des services de transport de personnes
            proposés sur le site <strong>hatransport.fr</strong>.
          </p>

          <Section title="1. Objet">
            <p>
              Ha Transport est une société de transport de personnes avec chauffeur (VTC) immatriculée au
              registre VTC sous le numéro <strong>EVTC 093 19 146</strong>, proposant des prestations de
              transfert aéroport, mise à disposition, transport longue distance et excursions touristiques.
            </p>
          </Section>

          <Section title="2. Réservation">
            <p>
              Toute réservation peut être effectuée via le formulaire en ligne, par téléphone au {company.phone}
              ou par e-mail à <a className="underline" href={`mailto:${company.email}`}>{company.email}</a>.
            </p>
            <p>
              Une réservation est considérée comme ferme et définitive après confirmation écrite (e-mail ou SMS)
              par Ha Transport. À défaut de confirmation, la prestation n'est pas garantie.
            </p>
            <p>Les informations suivantes doivent être communiquées : date, heure et lieu de prise en charge,
            destination, nombre de passagers et de bagages, numéro de vol/train le cas échéant, coordonnées
            du client.</p>
          </Section>

          <Section title="3. Tarifs">
            <p>Les tarifs sont exprimés en euros, toutes taxes comprises (TTC). Ils comprennent :</p>
            <ul className="list-disc list-inside ml-2 space-y-1">
              <li>Le carburant et les péages</li>
              <li>La mise à disposition du véhicule et du chauffeur</li>
              <li>Une attente offerte de 60 minutes pour les transferts aéroport</li>
              <li>Le suivi de vol en temps réel</li>
            </ul>
            <p className="mt-3"><strong>Forfaits aéroports (à titre indicatif)</strong> :</p>
            <ul className="list-disc list-inside ml-2 space-y-1">
              <li>Gamme Standard : 85 € (CDG / Orly / Disneyland ↔ Paris)</li>
              <li>Berline : 110 € (CDG / Orly ↔ Paris)</li>
              <li>Van : 129 € (CDG / Orly / Disneyland ↔ Paris)</li>
            </ul>
            <p>
              Pour les courses hors forfait, le tarif est calculé sur la base d'un minimum garanti (60 €
              Berline, 65 € Van, 35 € Standard) jusqu'à 15 km, puis au kilomètre.
            </p>
          </Section>

          <Section title="4. Paiement">
            <p>Le paiement s'effectue : par carte bancaire, espèces, virement bancaire ou facturation
            entreprise sur demande.</p>
            <p>Pour les réservations professionnelles, un délai de règlement à 30 jours peut être accordé
            sur acceptation du dossier.</p>
          </Section>

          <Section title="5. Annulation et modification">
            <p><strong>Annulation par le Client</strong> :</p>
            <ul className="list-disc list-inside ml-2 space-y-1">
              <li>Plus de 24 h avant la prise en charge : aucun frais</li>
              <li>Entre 24 h et 2 h avant : 50 % du montant TTC</li>
              <li>Moins de 2 h avant ou no-show : 100 % du montant TTC</li>
            </ul>
            <p>
              Toute modification (horaire, lieu, nombre de passagers) doit être communiquée au moins
              2 h avant la prise en charge et reste soumise à confirmation.
            </p>
          </Section>

          <Section title="6. Attente & retard">
            <p>
              Pour les transferts aéroport, le suivi de vol est inclus. Une attente gratuite de 60 minutes
              est offerte à compter de l'heure d'atterrissage. Au-delà, un supplément de 1 € la minute
              sera facturé.
            </p>
            <p>
              Pour les autres prises en charge, l'attente offerte est de 15 minutes. Au-delà, 1 € la minute.
            </p>
          </Section>

          <Section title="7. Bagages et passagers">
            <p>Le Client s'engage à respecter la capacité maximale du véhicule choisi :</p>
            <ul className="list-disc list-inside ml-2 space-y-1">
              <li>Standard (Tesla Model 3) : 4 passagers / 4 bagages</li>
              <li>Berline (Mercedes Classe E) : 2 passagers / 4 bagages</li>
              <li>Van (Mercedes Classe V) : 8 passagers / 10 bagages</li>
              <li>Sprinter, Minibus, Autocar : selon devis</li>
            </ul>
            <p>Tout dépassement non signalé peut entraîner un refus de prise en charge sans remboursement.</p>
            <p>Les sièges enfants sont fournis gratuitement sur demande lors de la réservation.</p>
          </Section>

          <Section title="8. Responsabilité">
            <p>
              Ha Transport est assuré pour le transport public de personnes auprès d'un assureur agréé. Le
              Prestataire est dégagé de toute responsabilité en cas de force majeure (intempéries, grève,
              accident, manifestation, etc.) entraînant un retard ou l'annulation de la prestation.
            </p>
            <p>
              Le Client est responsable de tout dégât occasionné au véhicule (souillure, casse) durant la
              prestation, et s'engage à en assumer les frais de remise en état.
            </p>
          </Section>

          <Section title="9. Comportement et règlement intérieur">
            <p>
              Il est strictement interdit de fumer (cigarettes électroniques comprises) et de consommer
              de la nourriture ou des boissons (hors eau) à bord. Tout passager en état d'ébriété manifeste
              ou présentant un comportement dangereux pourra se voir refuser l'accès au véhicule sans
              remboursement.
            </p>
          </Section>

          <Section title="10. Données personnelles">
            <p>
              Voir notre <a className="underline" href="/confidentialite">Politique de confidentialité</a>.
            </p>
          </Section>

          <Section title="11. Médiation et litiges">
            <p>
              En cas de litige, le Client est invité à contacter Ha Transport à l'adresse
              <a className="underline ml-1" href={`mailto:${company.email}`}>{company.email}</a> pour
              tenter de trouver une solution amiable.
            </p>
            <p>
              À défaut, conformément à l'article L.616-1 du Code de la consommation, le Client peut
              recourir gratuitement à un médiateur de la consommation. À défaut, les tribunaux français
              seront seuls compétents.
            </p>
          </Section>

          <p className="text-xs text-black/50 mt-12">Dernière mise à jour : mai 2026</p>
        </div>
      </article>
    </div>
  );
};

export default Cgv;
